import { render, staticRenderFns } from "./OpenPostReviewModalButton.vue?vue&type=template&id=d3b8d39e&"
import script from "./OpenPostReviewModalButton.vue?vue&type=script&lang=ts&"
export * from "./OpenPostReviewModalButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports